// Thumbnails for submission photos: a ~1000px JPEG copy stored alongside the original
// (at {company}/thumbs/{rest}) so PDF exports never download full-resolution originals.
// Best-effort everywhere: no thumb -> the export falls back to the original.

export const thumbPath = (path) => {
  const i = path.indexOf("/");
  return `${path.slice(0, i)}/thumbs/${path.slice(i + 1)}`;
};

export async function makeThumbnail(blob, max = 1000) {
  try {
    const bmp = await createImageBitmap(blob);
    const scale = Math.min(1, max / Math.max(bmp.width, bmp.height));
    if (scale === 1) { bmp.close?.(); return null; } // already small — original is the thumb
    const canvas = document.createElement("canvas");
    canvas.width = Math.round(bmp.width * scale);
    canvas.height = Math.round(bmp.height * scale);
    canvas.getContext("2d").drawImage(bmp, 0, 0, canvas.width, canvas.height);
    bmp.close?.();
    return await new Promise((res) => canvas.toBlob(res, "image/jpeg", 0.8));
  } catch {
    return null; // unsupported format (e.g. HEIC in some browsers) — fallback covers it
  }
}

// Fire-and-forget companion upload; never fails the main flow.
export async function uploadThumb(supabase, originalPath, blob) {
  try {
    const t = await makeThumbnail(blob);
    if (!t) return;
    await supabase.storage.from("submission-photos")
      .upload(thumbPath(originalPath), t, { contentType: "image/jpeg" });
  } catch { /* export falls back to the original */ }
}
